<template>
  <Layout
    :errors="errors"
    :title="trans(`models.settings.content.edit.action`)"
    :toasts="toasts"
    :resource="model"
  >
    <template #top>
      <resource-action-header
        :model="model"
        :action="'edit'"
        :description="model.data.attributes.description"
      ></resource-action-header>
    </template>
    <ul class="nav nav-tabs gap-1" style="margin: 0 0 -1px 0.5rem">
      <li class="nav-item" v-for="(setting, key) in $page.props.settings" :key="key">
        <Link
          :href="route(`${routePrefix}.settings.edit`, { id: setting.id })"
          :class="model.data.id === setting.id ? 'active' : 'text-muted'"
          class="nav-link"
        >
          <colored-icon
            :icon-class="setting.icon_class"
            :color="setting.icon_color"
            :shadow="false"
          ></colored-icon>
          {{ trans('models.settings.data.name.' + setting.ucid) }}
        </Link>
      </li>
<!--      <template v-if="model.data.id">-->
<!--        <template v-for="(collection, name) in model.data.collections" :key="name">-->
<!--          <li v-if="meta.editable.includes(name)" class="nav-item">-->
<!--            <button :class="focus === name ? 'active' : 'text-muted'" class="nav-link" @click="setFocus(name)">-->
<!--              {{ trans(`models.settings.relations.${name}`) }}-->
<!--            </button>-->
<!--          </li>-->
<!--        </template>-->
<!--      </template>-->
    </ul>
    <div v-if="model.data && focus === 'self'" class="card rounded-corner">
      <div class="card-body">
        <div class="row g-3 mb-2 mt-0">
          <div v-if="model" class="col-12">
            <h5>{{ model.data.attributes.name }}</h5>
            <div v-if="siteParams.data" class="form-container row">
              <div v-for="(siteParam, key) in siteParams.data" :key="key" class="form-section-container col-12">
                <div class="row form-element-container">
                  <div class="col-6">
                    <strong>{{ siteParam.data.attributes.name }}</strong>
                    <p>{{ siteParam.data.attributes.description }}</p>
                    <relation-link v-if="siteParam.data.attributes.feature_id" :value="siteParam.data.relations.feature"></relation-link>
                    <relation-link v-if="siteParam.data.attributes.module_id" :value="siteParam.data.relations.module"></relation-link>
                  </div>
                  <div class="col-6 d-flex flex-column">
                    <form-field
                      v-if="siteParam.data.attributes.has_values"
                      :id="model.data.attributes.ucid + '-' + siteParam.data.attributes.key"
                      :error="errors ? errors[siteParam.data.attributes.key] : null"
                      :label="null"
                      :name="siteParam.data.attributes.key"
                      :property-elements="siteParams.meta.propertyElements"
                      :resource-type="siteParams.meta.resourceType"
                      :field-type="'json'"
                      :value="siteParam.data.attributes['vals']"
                      :element="siteParams.meta.elements['vals'].form"
                      :disabled="siteParam.data.attributes.has_active_permission === false"
                      @update:attribute="(value) => siteParam.data.attributes['vals'] = value"
                    ></form-field>
                    <div class="row pt-2" v-if="siteParam.data.attributes.has_media && !siteParam.data.attributes['media'].length">
                      <div class="col position-relative media-container">
                        <div class="d-flex align-items-center justify-content-center border position-relative media-element">
                          <img :src="siteParam.data.attributes['fallback_media'].file_name" :title="'Fallback'" class="border mh-100 mw-100" />
                        </div>
                        <a :href="siteParam.data.attributes['fallback_media'].file_name" class="d-block border border-top-0 p-2 text-truncate" target="_blank">
                          <i class="bi bi-paperclip"></i>
                          <span :title="siteParam.data.attributes['fallback_media'].file_name">{{ siteParam.data.attributes['fallback_media'].file_name }}</span>
                        </a>
                      </div>
                    </div>
                    <form-field
                      v-if="siteParam.data.attributes.has_media"
                      :id="model.data.attributes.ucid + '-' + siteParam.data.attributes.key + '-media'"
                      :error="errors ? errors[siteParam.data.attributes.key] : null"
                      :label="null"
                      :name="siteParam.data.attributes.key + '-media'"
                      :field-type="'media'"
                      :value="siteParam.data.attributes['media']"
                      :element="siteParams.meta.elements['media'].form"
                      @update:media="(media) => updateMedia(siteParam, media)"
                    ></form-field>
                    <div v-if="siteParam.data.attributes.has_active_permission === false" class="text-muted">
                      Diese Einstellung kann derzeit nicht aktiviert werden, da die dafür notwendige Berechtigung global deaktiviert ist: {{ siteParam.data.attributes.role_permission_key }}
                    </div>
                    <button
                      class="btn btn-primary position-relative align-self-end mt-3"
                      style="padding-left: 2.25rem"
                      type="button"
                      :disabled="siteParam.data.attributes.has_active_permission === false"
                      @click="saveSiteParam(siteParam)"
                    >
                      Speichern
                      <i class="fa-solid fa-floppy-disk position-absolute lh-1 start-0 ms-2"></i>
                    </button>
                  </div>
                </div>
                <hr class="border-1">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #right>
      <admin-sidebox :resource="model"></admin-sidebox>
    </template>
  </Layout>
</template>

<script>
import Card from '@kanrisha/components/Base/Card';
import Layout from '@kanrisha/Pages/Layout';
import ResourceForm from '@kanrisha/components/ResourceForm';
import ResourceActionButtons from '@kanrisha/components/Links/ResourceActionButtons';
import ResourceCollection from '@kanrisha/components/ResourceCollection';
import ResourceSelection from '@kanrisha/components/ResourceSelection';
import useModels from '@kanrisha/composables/useModels';
import { ref } from 'vue';
import { Link, router } from '@inertiajs/vue3';
import useResource from '@kanrisha/composables/useResource';
import useToasts from '@kanrisha/composables/useToasts';
import AdminSidebox from '@kanrisha/components/Layout/AdminSidebox';
import PickedResourceCard from '@kanrisha/components/Cards/PickedResource';
import RelationCollectionCard from '@kanrisha/components/Cards/RelationCollection';
import ResourceActionHeader from '@kanrisha/components/Layout/ResourceActionHeader';
import FormField from "@kanrisha/components/Form/FormField";
import ColoredIcon from "@kanrisha/components/Icons/ColoredIcon";
import RelationLink from "@kanrisha/components/Elements/Display/RelationLink";

export default {
  components: {
    RelationLink,
    ColoredIcon,
    FormField,
    AdminSidebox,
    Card,
    Layout,
    Link,
    PickedResourceCard,
    RelationCollectionCard,
    ResourceActionButtons,
    ResourceActionHeader,
    ResourceCollection,
    ResourceForm,
    ResourceSelection,
  },
  props: {
    aspectMenuItems: { type: Object, default: () => {} },
    model: { type: Object, default: () => {} },
    settings: { type: Object, default: () => {} },
    logEntries: { type: Object, default: () => {} },
    toasts: { type: Object, default: () => {} },
    errors: { type: Object, default: () => {} },
  },
  emits: ['update:toast'],
  setup(props) {
    const { meta, resourceType } = useResource(props, props.model);
    const { addToasts } = useToasts(props);
    const focus = ref(props.model.meta.adjustments.focus ?? 'self');
    const siteParams = ref(props.model.data.collections.site_params);

    const setFocus = (name) => {
      const { focus: setFocusAdjustment } = useModels({ resourceType: 'settings' });
      setFocusAdjustment(props.model.meta.resourceType, name);
      focus.value = name;
    };


    const saveSiteParam = (siteParam) => {
      let { storeModel } = useModels({ resourceType: 'site-params' });
      storeModel(siteParam, 'site-params');
    }

    const updateMedia = (siteParam, mediaItems) => {
      siteParam.media = mediaItems;
      siteParam.data.attributes.media_ids = mediaItems.filter((item) => !item.remove).map((item) => item.id);
      siteParam.data.attributes.remove_media_ids = mediaItems
        .filter((item) => item.remove)
        .map((item) => item.id);
    };

    return {
      addToasts,
      focus,
      meta,
      resourceType,
      saveSiteParam,
      setFocus,
      siteParams,
      updateMedia,
    };
  },
};
</script>

<style type="text/css">
  .media-container {
    max-width: 100%;
  }
</style>